/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { isEmpty } from '@ember/utils';
import Component from '@glimmer/component';
import SubscriptionPageModel from 'cio/models/subscription-page';
import SubscriptionTopicModel from 'cio/models/subscription-topic';
import SubscriptionCenterService from 'cio/services/subscription-center';
import { LogoSource, SubscriptionCenterNavTabs, SubscriptionCenterSettings } from 'cio/utils/subscription-center';
import { inject as service } from '@ember/service';
import FeaturesService from 'ember-feature-flags/services/features';

interface SubscriptionCenterBrandingPreviewArgs {
  topics: SubscriptionTopicModel[];
  brandingValues: SubscriptionCenterSettings;
  savePreferencesButtonStyles: string;
  pageContent?: SubscriptionPageModel;
  activeTab: SubscriptionCenterNavTabs;
}

export default class SubscriptionCenterBrandingPreview extends Component<SubscriptionCenterBrandingPreviewArgs> {
  @service subscriptionCenter!: SubscriptionCenterService;
  @service features!: FeaturesService;

  readonly LogoSource = LogoSource;

  get isMissingTitle() {
    return isEmpty(this.args.pageContent?.header.title);
  }

  get isMissingSubtitle() {
    return isEmpty(this.args.pageContent?.header.subtitle);
  }

  get header() {
    let headerTxt = 'Header';
    let headlineTxt = 'Headline';

    if (this.args.pageContent) {
      let { title, subtitle } = this.args.pageContent.header;
      if (!isEmpty(title)) {
        headerTxt = title;
      }
      if (!isEmpty(subtitle)) {
        headlineTxt = subtitle;
      }
    }

    return {
      title: headerTxt,
      subtitle: headlineTxt,
    };
  }

  get showTopicsView() {
    return (
      this.subscriptionCenter.enabled ||
      this.args.activeTab === SubscriptionCenterNavTabs.Topics ||
      isEmpty(this.args.activeTab)
    );
  }

  get showGlobalUnsubscribeView() {
    return !this.subscriptionCenter.enabled && this.args.activeTab === SubscriptionCenterNavTabs.GlobalUnsubscribe;
  }
}
